import { Characteristics, Consumption, EcoRating, InflateRequestMode } from '@sccs/types';
import { TranslationType } from '../../util/i18n';
import {
  OneSearchGraphQlVehicle,
  TypeContext,
  getEcoRating,
  getEmissionData,
  getEmissionFootnotesString,
  getEngineDescriptionOneSearch,
  getFinalInspectionDate,
  getFuelType,
  getGearbox,
  technicalDataConfigurationForMarkets,
  type ParsedTechnicalData,
} from '../VehicleTechnicalDataUtils';

export const technicalDataParserOneSearch = (
  product: OneSearchGraphQlVehicle,
  market: string,
  language: string,
  mode: InflateRequestMode,
  translations: (key: string, dataset?: TranslationType) => string,
) => {
  const getConfiguredTechnicalData = (): Partial<ParsedTechnicalData> => {
    const parsedTechnicalData: Partial<ParsedTechnicalData> = {};

    const addIfConfiguredForMarket = (
      key: keyof ParsedTechnicalData,
      getValue: () => Characteristics | EcoRating | Consumption[] | string | null | undefined,
    ) => {
      if (technicalDataConfigurationForMarkets(key, market, TypeContext.ONESEARCH)) {
        const value = getValue();
        if (!value) return;
        if (key === 'engineDescription' || key === 'finalInspectionDate' || key === 'fuelType' || key === 'gearBox') {
          parsedTechnicalData[key] = value as Characteristics;
        }
        if (key === 'emissionData') {
          parsedTechnicalData[key] = value as Consumption[];
        }
        if (key === 'ecoRating') {
          parsedTechnicalData[key] = value as EcoRating;
        }
        // FIXME: this conversion shouldn't be required. Footnotes are returned as a string by getEmissionFootnotesString
        // but are required as an object here?
        if (key === 'emissionFootnotes' && typeof value === 'string') {
          parsedTechnicalData[key] = value as unknown as Record<string, string>;
        }
      }
    };

    addIfConfiguredForMarket('engineDescription', () => getEngineDescriptionOneSearch(product, translations));
    addIfConfiguredForMarket('emissionData', () =>
      getEmissionData(product, TypeContext.ONESEARCH, language, translations, market),
    );
    addIfConfiguredForMarket('finalInspectionDate', () => getFinalInspectionDate(product, mode, TypeContext.ONESEARCH));
    addIfConfiguredForMarket('emissionFootnotes', () => getEmissionFootnotesString(product));
    addIfConfiguredForMarket('ecoRating', () => getEcoRating(product, language, TypeContext.ONESEARCH));
    addIfConfiguredForMarket('fuelType', () => getFuelType(product, TypeContext.ONESEARCH));
    addIfConfiguredForMarket('gearBox', () => getGearbox(product, TypeContext.ONESEARCH));

    return parsedTechnicalData;
  };

  return {
    getTechnicalData: getConfiguredTechnicalData,
  };
};
export { ParsedTechnicalData };
